import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import tokenManagerService from './services/tokenManager'

Vue.config.productionTip = false

// Initialize token manager
tokenManagerService.initialize();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
